'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CustomerService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = require('../core/utils');

var _utils2 = require('./utils');

var _user = require('../environment/winres/user.js');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Customer-specific API calls
var CustomerService /*haha!*/ = exports.CustomerService = function () {
    function CustomerService(winresCloudService, $q) {
        _classCallCheck(this, CustomerService);

        this.winresCloudService = winresCloudService;
        this.$q = $q;
    }

    _createClass(CustomerService, [{
        key: 'isLoggedInAsCustomer',
        value: function isLoggedInAsCustomer() {
            var user = this.winresCloudService.getUser();
            return user && isActiveCustomer(user);
        }
    }, {
        key: 'isLoggedInAsNewCustomer',
        value: function isLoggedInAsNewCustomer() {
            var user = this.winresCloudService.getUser();
            return user && isNewCustomer(user);
        }
    }, {
        key: 'isLoggedInAsSomeOtherUserType',
        value: function isLoggedInAsSomeOtherUserType() {
            var user = this.winresCloudService.getUser();
            return user && !isAnyCustomer(user);
        }
    }, {
        key: 'getConnectionNameIfLoggedIn',
        value: function getConnectionNameIfLoggedIn() {
            var user = this.winresCloudService.getUser();
            return user ? user.getDomain() : null;
        }
    }, {
        key: 'getOfficeSiteParameters',
        value: function getOfficeSiteParameters(connectionName) {
            // NOTE: Request is not authenticated.z
            return this.winresCloudService.makeRequest('GetOfficeSiteParameters', {
                "ConnectionName": connectionName
            });
        }
    }, {
        key: 'getUserCustomerNumberWhenAvailable',
        value: function getUserCustomerNumberWhenAvailable() {
            return this.winresCloudService.getUserWhenAvailable().then(function (user) {
                if (isAnyCustomer(user)) {
                    return user.getCustomerId();
                } else {
                    console.warn('[CS] Logged in as a non-customer user', user.getUserName(), ' with user type ', user.getUserType());
                    // TODO: Wait for new login here.
                    throw '[CS] User is not a customer.';
                }
            });
        }
    }, {
        key: 'getCustomer',
        value: function getCustomer(customerNumber) {
            return this.winresCloudService.makeAuthenticatedRequest('GetCustomer', {
                "CustomerNumber": customerNumber
            });
        }
    }, {
        key: 'sendEmail',
        value: function sendEmail(emailObject) {
            return this.winresCloudService.makeAuthenticatedRequest('SendEMail', {
                "Mail": emailObject
            });
        }
        // Misleading name, updates if exists.

    }, {
        key: 'insertCustomer',
        value: function insertCustomer(customer) {
            return this.winresCloudService.makeAuthenticatedRequest('InsertCustomer', {
                'Customer': customer
            });
        }
    }, {
        key: 'updatePassenger',
        value: function updatePassenger(customerNumber, bookingNumber, passenger) {
            return this.winresCloudService.makeAuthenticatedRequest('UpdatePassenger', {
                'CustomerNumber': customerNumber,
                'BookingNumber': bookingNumber,
                'Passenger': passenger
            });
        }
    }, {
        key: 'changeCustomerPassword',
        value: function changeCustomerPassword(oldPassword, newPassword) {
            return this.winresCloudService.makeAuthenticatedRequest('ChangeCustomerPassword', {
                'OldPassword': oldPassword,
                'NewPassword': newPassword
            });
        }
    }, {
        key: 'sendCustomerAccountRecoveryMail',
        value: function sendCustomerAccountRecoveryMail(connectionName, email) {
            // NOTE: Request is not authenticated.
            return this.winresCloudService.makeRequest('SendCustomerAccountRecoveryMail', {
                'ConnectionName': connectionName,
                'Email': email
            });
        }
    }, {
        key: 'recoverCustomerAccountWithToken',
        value: function recoverCustomerAccountWithToken(connectionName, email, token, newPassword) {
            // NOTE: Request is not authenticated.
            return this.winresCloudService.makeRequest('RecoverCustomerAccountWithToken', {
                'ConnectionName': connectionName,
                'Email': email,
                'Token': token,
                'NewPassword': newPassword
            });
        }
    }, {
        key: 'getCustomerBookingList',
        value: function getCustomerBookingList(customerNumber, endDateFrom, endDateTo, language) {
            if (endDateFrom instanceof Date) {
                endDateFrom = (0, _utils.formatISODate)(endDateFrom);
            }
            if (endDateTo instanceof Date) {
                endDateTo = (0, _utils.formatISODate)(endDateTo);
            }
            return this.winresCloudService.makeAuthenticatedRequest('GetCustomerBookingList', {
                'CustomerNumber': customerNumber,
                'EndDateFrom': endDateFrom,
                'EndDateTo': endDateTo,
                'Language': language
            }, true);
        }
    }, {
        key: 'getCustomerBooking',
        value: function getCustomerBooking(customerNumber, bookingNumber, language) {
            return this.winresCloudService.makeAuthenticatedRequest('GetCustomerBooking', {
                'CustomerNumber': customerNumber,
                'BookingNumber': bookingNumber,
                'Language': language
            }, true);
        }
    }, {
        key: 'getCustomerBookingBalance',
        value: function getCustomerBookingBalance(customerNumber, bookingNumber) {
            return this.winresCloudService.makeAuthenticatedRequest('GetCustomerBookingBalance', {
                'CustomerNumber': customerNumber,
                'BookingNumber': bookingNumber
            }, true);
        }
    }, {
        key: 'getCustomerReservableExtraServices',
        value: function getCustomerReservableExtraServices(customerNumber, bookingNumber, language) {
            return this.winresCloudService.makeAuthenticatedRequest('GetCustomerReservableExtraServices', {
                'CustomerNumber': customerNumber,
                'BookingNumber': bookingNumber,
                'Language': language
            }, true).then(function (result) {
                if (!result) {
                    throw '[CS] GetCustomerReservableExtraServices returned null.';
                }

                var relevantByDest = _.groupBy(result.RelevantProducts, function (p) {
                    return p.DestinationInfo.DestinationCode;
                });
                var relevantByDestAndProd = _.mapValues(relevantByDest, function (xs) {
                    return _.keyBy(xs, function (p) {
                        return p.DestinationInfo.ProductCode;
                    });
                });

                var linesByDest = _.groupBy(result.ExtraServiceProductLines, function (line) {
                    return line.DestinationCode;
                });
                var linesByDestAndProd = _.mapValues(linesByDest, function (xs) {
                    return _.groupBy(xs, function (line) {
                        return line.ProductCode;
                    });
                });

                return {
                    Lookups: {
                        RelevantProducts: relevantByDestAndProd,
                        ExtraServiceProductLines: linesByDestAndProd
                    },
                    Passengers: result.Passengers,
                    ExtraServiceProductLines: result.ExtraServiceProductLines,
                    ReservableExtraServices: result.ReservableExtraServices
                };
            });
        }
    }, {
        key: 'getCustomerAreaServices',
        value: function getCustomerAreaServices(customerNumber, bookingNumber, language) {
            return this.winresCloudService.makeAuthenticatedRequest('GetCustomerAreaServices', {
                'CustomerNumber': customerNumber,
                'BookingNumber': bookingNumber,
                'Language': language
            }, true).then(function (result) {
                if (!result) {
                    throw '[CS] getCustomerAreaServices returned null.';
                }

                return {
                    CustomerAreaServices: result
                };
            });
        }
    }, {
        key: 'getCustomerReservableAreaServices',
        value: function getCustomerReservableAreaServices(customerNumber, bookingNumber, language, beginDate, endDate) {
            return this.winresCloudService.makeAuthenticatedRequest('GetCustomerReservableAreaServices', {
                'CustomerNumber': customerNumber,
                'BookingNumber': bookingNumber,
                'Language': language,
                'BeginDate': beginDate,
                'EndDate': endDate
            }, true).then(function (result) {
                if (!result) {
                    throw '[CS] getCustomerReservableAreaServices returned null.';
                }

                // [object (array)]: {
                //   [BeginDate]: BeginDate
                //   [DestinationCode]: DestinationCode
                //   [ProductCode]: ProductCode
                // }
                // ->
                // [timeStamp (array)]: {
                //   [DestinationCode (array)]: {
                //     [ProductCode (array)]: [object]
                //   }
                // }

                var relevantByTimeStamp = _.groupBy(result.RelevantProducts, function (p) {
                    return moment(p.BeginDate).format("YYYYMMDD");
                });

                var relevant = {};
                _.each(relevantByTimeStamp, function (r, timeStamp) {
                    var relevantByDest = _.groupBy(r, function (p) {
                        return p.DestinationInfo.DestinationCode;
                    });

                    var relevantByDestAndProd = _.mapValues(relevantByDest, function (xs) {
                        return _.keyBy(xs, function (p) {
                            return p.DestinationInfo.ProductCode;
                        });
                    });

                    relevant[timeStamp] = relevantByDestAndProd;
                });

                var linesByTimeStamp = _.groupBy(result.AreaServiceProductLines, function (line) {
                    return moment(line.BeginDate).format('YYYYMMDD');
                });

                var lines = {};
                _.each(linesByTimeStamp, function (l, timeStamp) {
                    var linesByDest = _.groupBy(l, function (line) {
                        return line.DestinationCode;
                    });
                    var linesByDestAndProd = _.mapValues(linesByDest, function (xs) {
                        return _.groupBy(xs, function (p) {
                            return p.ProductCode;
                        });
                    });

                    lines[timeStamp] = linesByDestAndProd;
                });

                return {
                    Lookups: {
                        AreaServices: result.AreaServiceTimeStamps,
                        RelevantProducts: relevant,
                        AreaServiceProductLines: lines
                    }
                };
            });
        }
    }, {
        key: 'bookCustomerExtraServices',
        value: function bookCustomerExtraServices(customerNumber, bookingNumber, productLines) {
            return this.winresCloudService.makeAuthenticatedRequest('BookCustomerExtraServices', {
                'CustomerNumber': customerNumber,
                'BookingNumber': bookingNumber,
                'ProductLines': productLines
            }, true);
        }
    }, {
        key: 'getCustomerPaymentMethods',
        value: function getCustomerPaymentMethods(customerNumber, bookingNumber, amountToPay) {
            if (amountToPay === undefined) {
                amountToPay = null;
            }

            var language = this.winresCloudService.getLanguage();

            return this.winresCloudService.makeAuthenticatedRequest('GetCustomerPaymentMethods', {
                'CustomerNumber': customerNumber,
                'BookingNumber': bookingNumber,
                'AmountToPay': amountToPay, // If null, the full unpaid amount is used
                'Language': language
            }, true);
        }
    }, {
        key: 'payCustomerBooking',
        value: function payCustomerBooking(customerNumber, bookingNumber, paymentSettings, language) {
            return this.winresCloudService.makeAuthenticatedRequest('PayCustomerBooking', {
                'CustomerNumber': customerNumber,
                'BookingNumber': bookingNumber,
                'InternalName': paymentSettings.internalName,
                'OkUrl': paymentSettings.okUrl,
                'CancelUrl': paymentSettings.cancelUrl,
                'RejectUrl': paymentSettings.rejectUrl,
                'AmountToPay': paymentSettings.amountToPay, // If null, the full unpaid amount is used
                'Language': language
            }, true);
        }
    }, {
        key: 'confirmCustomerPaymentByReturnUrl',
        value: function confirmCustomerPaymentByReturnUrl(returnUrl) {
            return this.winresCloudService.makeAuthenticatedRequest('ConfirmCustomerPaymentByReturnUrl', {
                'ReturnUrl': returnUrl
            }, true);
        }
    }, {
        key: 'getBookingFiles',
        value: function getBookingFiles(bookingNumber, customerNumber) {
            //this.winresCloudService.getUser();
            return this.winresCloudService.makeAuthenticatedRequest('ListBookingFiles', {
                "BookingNumber": bookingNumber
            }, true);
        }
    }, {
        key: 'getBookingLinks',
        value: function getBookingLinks(bookingNumber) {
            return this.winresCloudService.makeAuthenticatedRequest('ListBookingLinks', {
                "BookingNumber": bookingNumber
            }, true);
        }
    }, {
        key: 'getCustomerBookingFiles',
        value: function getCustomerBookingFiles(bookingNumber) {
            return this.winresCloudService.makeAuthenticatedRequest('ListCustomerBookingFiles', {
                "BookingNumber": bookingNumber
            }, true);
        }
    }, {
        key: 'getDepartureDocuments',
        value: function getDepartureDocuments(destCode, beginDate, endDate) {
            return this.winresCloudService.makeAuthenticatedRequest('ListDepartureDocuments', {
                'DestCode': destCode,
                'BeginDate': beginDate,
                'EndDate': endDate
            }, true);
        }
    }, {
        key: 'loadPrivateCustomerBookingFile',
        value: function loadPrivateCustomerBookingFile(file) {
            return this.$q(function (resolve, reject) {
                var reader = new FileReader();

                reader.readAsArrayBuffer(file);
                reader.onloadend = function (e) {
                    var arr = new Uint8Array(e.target.result).subarray(0, 5);

                    var header = "";
                    for (var i = 0; i < arr.length; i++) {
                        header += arr[i].toString(16);
                    }

                    var dataReader = new FileReader();

                    // Read base64 as string
                    dataReader.readAsDataURL(file);

                    dataReader.onload = function () {
                        return resolve({ valid: validFileSize(file.size) && validFileHeader(header),
                            error: !validFileSize(file.size) ? 1 : !validFileHeader(header) ? 2 : null,
                            base64: dataReader.result
                        });
                    };

                    dataReader.onerror = function (error) {
                        return reject(error);
                    };
                };
            });
        }
    }, {
        key: 'uploadPrivateCustomerBookingFile',
        value: function uploadPrivateCustomerBookingFile(bookingNumber, file, overwrite) {
            // Upload customer booking file
            // File name is generated by Type
            return this.winresCloudService.makeAuthenticatedRequest('UploadCustomerBookingFile', {
                "BookingNumber": bookingNumber,
                "Base64": file.base64,
                "Type": file.selectedType,
                "Overwrite": overwrite
            }, true);
        }
    }, {
        key: 'isCustomerUploadInUse',
        value: function isCustomerUploadInUse() {
            return this.winresCloudService.makeAuthenticatedRequest('IsCustomerUploadInUse', {}, true);
        }
    }, {
        key: 'getCustomerBookingFileTypes',
        value: function getCustomerBookingFileTypes() {
            return this.winresCloudService.makeAuthenticatedRequest('GetCustomerBookingFileTypes', {}, true);
        }
    }]);

    return CustomerService;
}();

function validFileSize(size) {
    return size < 5240000; // 5 MB
}

// function validFileType(type, header) {
//   var valid = false;

//   switch (type) {
//       case "text/plain":
//           valid = true;
//           break;
//       default:
//           valid = false;
//   }

//   return valid || validFileHeader(header);
// }


function validFileHeader(header) {
    // https://en.wikipedia.org/wiki/List_of_file_signatures

    var validHeaders = {
        // "61626364", // "text/plain"
        // "89504e47", // "image/png"
        // "47494638", // "image/gif"
        "ffd8ffe0": "image/jpeg",
        "ffd8ffe1": "image/jpeg",
        "ffd8ffe2": "image/jpeg",
        "ffd8ffe3": "image/jpeg",
        "ffd8ffe8": "image/jpeg",
        // "424db2b", // "image/bmp"
        // "47494638", // "image/gif"
        // "38425053", // "psd"
        // "504b34", // "application/vnd.oasis.opendocument.spreadsheet (ods, xlsx)"
        // "7469746c", // "csv"
        // "49442c22", // "csv"
        // "3c3f786d", // "text/xml"
        // "d0cf11e0", // "doc, xls, ppt, msg"
        "255044462d": "application/pdf"
    };

    var match = _.findKey(validHeaders, function (value, key) {
        return header.startsWith(key);
    });
    if (match) {
        var type = validHeaders[match];
        console.log('[CustomerService] File header', header, 'matches file type', type);
        return true;
    } else {
        var _console;

        var validTypes = _.uniq(_.values(validHeaders));
        (_console = console).warn.apply(_console, ['[CustomerService] File header', header, 'does not match any allowed file type.', 'Allowed types are:'].concat(_toConsumableArray(validTypes)));
        return false;
    }
}

function isNewCustomer(user) {
    return user.getUserType() == _user.LOGIN_TYPE_CUSTOMER_NEW && user.getCustomerId();
}

function isActiveCustomer(user) {
    return user.getUserType() == _user.LOGIN_TYPE_CUSTOMER && user.getCustomerId();
}

function isAnyCustomer(user) {
    return isNewCustomer(user) || isActiveCustomer(user);
}

CustomerService.$inject = ['winresCloudService', '$q'];


//////////////////
// WEBPACK FOOTER
// ./src/winresCloud/customerService.js
// module id = 556
// module chunks = 2